var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.003,
    height: 40,
    viewBox: "0 0 40.003 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discover",
    transform: "translate(-303.999 -206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149974",
    "data-name": "Rectangle 149974",
    width: 40,
    height: 40,
    transform: "translate(304.002 206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Discover-dark",
    transform: "translate(303.906 213.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(0.093 0.056)",
    fill: "#fff",
    stroke: "#e6772f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 23,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M-.305,11.514H29.21c.888,0,2.194-1.656,2.194-2.543V.008S19.42,8.246-.305,11.514Z",
    transform: "translate(8.691 12.542)",
    fill: "#e6772f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M1.386,4.655H0V0H1.394A2.374,2.374,0,0,1,4.005,2.329a2.308,2.308,0,0,1-.883,1.788A2.613,2.613,0,0,1,1.386,4.655ZM.949.788V3.867H1.2A1.866,1.866,0,0,0,2.5,3.5a1.572,1.572,0,0,0,.523-1.174A1.538,1.538,0,0,0,2.5,1.165,1.814,1.814,0,0,0,1.2.788Z",
    transform: "translate(4.846 8.488)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M0,0H.945V4.656H0Z",
    transform: "translate(9.289 8.488)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M1.961,1.862c-.571-.2-.737-.334-.737-.585,0-.292.3-.514.708-.514a1,1,0,0,1,.768.375l.494-.62A2.174,2.174,0,0,0,1.765,0,1.4,1.4,0,0,0,.248,1.331c0,.644.305.97,1.2,1.28a3.647,3.647,0,0,1,.657.266.549.549,0,0,1,.284.48.681.681,0,0,1-.737.657A1.127,1.127,0,0,1,.612,3.392L0,3.958a1.914,1.914,0,0,0,1.684.887,1.543,1.543,0,0,0,1.679-1.53c0-.741-.322-1.076-1.4-1.454",
    transform: "translate(10.594 8.411)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M0,2.434a2.468,2.468,0,0,0,2.569,2.43,2.712,2.712,0,0,0,1.187-.271V3.523a1.538,1.538,0,0,1-1.146.51A1.553,1.553,0,0,1,.978,2.428,1.58,1.58,0,0,1,2.569.83a1.613,1.613,0,0,1,1.187.524V.285A2.512,2.512,0,0,0,2.588,0,2.5,2.5,0,0,0,0,2.434",
    transform: "translate(14.255 8.383)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    "data-name": "Fill 17",
    d: "M2.332,3.126,1.034,0H0L2.062,4.773h.509L4.674,0H3.647L2.332,3.126",
    transform: "translate(23.367 8.488)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M0,4.656H2.691V3.867H.949V2.61H2.624V1.821H.949V.788H2.691V0H0V4.656",
    transform: "translate(28.471 8.488)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M.951,4.656H0V0H1.409C2.5,0,3.13.5,3.13,1.374a1.253,1.253,0,0,1-1.107,1.32l1.53,1.961H2.386L1.075,2.784H.951V4.655Zm0-3.923V2.141h.276c.606,0,.926-.248.926-.716,0-.452-.315-.692-.91-.692Z",
    transform: "translate(31.788 8.488)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M5.072,2.427A2.483,2.483,0,0,1,2.536,4.854,2.483,2.483,0,0,1,0,2.427,2.483,2.483,0,0,1,2.536,0,2.483,2.483,0,0,1,5.072,2.427",
    transform: "translate(18.428 8.401)",
    fill: "#e6772f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.e4ea013f7e4f1b4010c7fe7503d7ce03.svg";
export { ForwardRef as ReactComponent };